import { apiClient } from "../config";

async function getSurveyDetailsByToken(token: string) {
  const res = await apiClient.get(`/survey-and-polls/${token}`);

  return res.data;
}

export default getSurveyDetailsByToken;
